import React, { useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from 'recharts';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled(ResponsiveContainer)`
  .text-major {
    font-size: 20px;
  }
`;

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props;

  return (
    <g>
      <text
        x={cx}
        y={cy - 12}
        dy={8}
        textAnchor="middle"
        fill="#6c757d"
        className="text-major d-block font-weight-bold"
      >
        {payload.channel}
      </text>
      <text
        x={cx}
        y={cy + 12}
        dy={8}
        textAnchor="middle"
        fill="#6c757d"
        className="text-major d-block"
      >
        {payload.amount.toLocaleString()}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 4}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius - 4}
        outerRadius={innerRadius - 2}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const COLORS = [`#4fc6e1`, `#7e57c2`, `#f672a7`];

function PieChartCard(props) {
  const { title, top, other, formatNumber } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const { t } = useAutoTranslation();

  return (
    <div className="col-xl-4 col-md-6">
      <div className="card">
        <div className="card-body" dir="ltr">
          <div className="card-widgets">
            <p className="text-muted font-13 mb-0 text-truncate">{t('За 30 дней')}</p>
          </div>
          <h4 className="header-title mb-0">{title}</h4>
          <div id="cardCollpase1" className="collapse pt-3 show">
            <div className="text-center">
              <div className="row mt-2 justify-content-around">
                {top.map((item) => (
                  <div className={`col-${12 / (top.length + !!other)}`} key={item.channel}>
                    <h4 data-plugin="counterup">{formatNumber(item.amount)}</h4>
                    <p className="text-muted font-13 mb-0 text-truncate">{item.channel}</p>
                  </div>
                ))}
                {other ? (
                  <div className="col-2.4">
                    <h4 data-plugin="counterup">{formatNumber(other.amount)}</h4>
                    <p className="text-muted font-13 mb-0 text-truncate">{t('Прочее')}</p>
                  </div>
                ) : null}
              </div>
              <div className="mt-3">
                <Wrapper width="100%" height={300}>
                  <PieChart>
                    <Pie
                      activeIndex={activeIndex}
                      activeShape={renderActiveShape}
                      innerRadius={95}
                      outerRadius={130}
                      onMouseEnter={(data, index) => setActiveIndex(index)}
                      paddingAngle={0}
                      data={other ? [...top, other] : top}
                      dataKey="amount"
                    >
                      {top.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index]} stroke={COLORS[index]} />
                      ))}
                      {other && <Cell key="cell-other" fill="#ebeff2" stroke="#ebeff2" />}
                    </Pie>
                  </PieChart>
                </Wrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PieChartCard;
